<template>
  <div class="w-full max-w-7xl mx-auto px-[4vw] pb-12">
    <Head>
      <Title>{{ $t('campaigns.sthlmfw.meta.title') }}</Title>
      <Meta name="description" :content="$t('campaigns.sthlmfw.meta.description')" />
    </Head>
    <div class="mt-2 lg:mt-8 mb-6">
      <div class="flex flex-col gap-4 xl:gap-8 xl:flex-row xl:flex xl:items-end">
        <div class="xl:w-1/2">
          <div class="flex gap-2 items-center text-xs mb-4 xl:mb-6">
            <CampaignsStockholmFashionWeekBreadcrumbs />
          </div>
          <div class="grid gap-2" v-auto-animate>
            <h1 class="font-heading font-bold text-4xl sm:text-5xl md:text-6xl _lg:text-7xl max-w-[16ch]">{{ $t('campaigns.sthlmfw.heading') }}</h1>
            <p class="md:text-lg md:leading-7 max-w-[48ch]" v-html="$t('campaigns.sthlmfw.leading')" />
          </div>
          <div class="mt-4">
            <CampaignsStockholmFashionWeekNavCityParts />
          </div>
        </div>
        <div class="xl:w-1/2">
          <CampaignsStockholmFashionWeekNav />
        </div>
      </div>
    </div>
    <div v-if="restaurants?.length === 0">
      <AtomInfoBox
        :heading="$t('shared.noData.offers.heading')"
        :description="$t('shared.noData.offers.description', { city: city?.name, date: dayjs(date).format('D MMMM YYYY') })"
      />
    </div>
    <div class="grid gap-4 sm:gap-6 sm:grid-cols-2 lg:grid-cols-3 overflow-hidden relative" v-auto-animate>
      <CampaignsStockholmFashionWeekCard 
        v-for="restaurant in restaurants" 
        :key="restaurant.id" 
        :restaurant="restaurant" 
        :pending="status === 'pending'" />
    </div>
    <div class="mt-6 md:mt-8">
      <NuxtLink class="flex items-center gap-2 mt-4" :to="`/${$t('routes.offers')}/${city?.slug}?date=${date}`">
        <div class="w-5 h-5 flex items-center justify-center rounded-full bg-sky text-ocean">
          <AtomIcon name="chevron-right" class="text-sm" />
        </div>
        <div class="text-sm">{{ $t('shared.moreOffers', { city: city?.name }) }}</div>
      </NuxtLink>
    </div>
    <!-- Debug data -->
    <div class="grid gap-4" v-if="$route.query?.debug && status === 'success'">
      <hr class="my-8">
      <div class="font-bold">Offers</div>
      <table class="debug-table">
        <tbody>
          <tr>
            <th class="w-12">ID</th>
            <th class="w-1/4">Restaurant</th>
            <th class="w-12">Rank</th>
            <th class="w-12">Meals</th>
          </tr>
          <tr v-for="restaurant in restaurants" :key="restaurant.id">
            <td v-html="restaurant?.id" />
            <td v-html="restaurant?.name" />
            <td v-html="restaurant?.rank" />
            <td v-html="restaurant?.meals?.map(meal => meal?.name).join(', ')" />
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script async setup>
definePageMeta({
  middleware: 'stockholm-fashion-week'
})

const dayjs = useDayjs()
const route = useRoute()
const fat = useFatStore()
const app = useAppStore()

// Get date from query param
const date = computed(() => route.query?.date || '2025-06-02')

// Get city ID's for Stockholm
const city = app.cities?.find(city => city.slug === 'stockholm')
const cityIds = [city.id, ...city?.relatedCityIds]

// Fetch FAT result for Offers
const { data, status } = await useFetch('/search/fat', {
  key: `campaigns-stockholm-fashion-week`,
  baseURL: useEnv('apiBase'),
  query: {
    date: computed(() => date.value),
    cityIds: computed(() => cityIds.join(',')),
    amount: computed(() => fat.amount || 2),
    timeslotsRange: computed(() => fat.timeRange),
    mealTypes: 11,
    altType: 4,
    tagIds: computed(() => (!fat.restaurantIds.length && fat.tagIdsQuery)
      ? fat.tagIdsQuery
      : undefined),
  }
})

// Grep restaurants from payload
const restaurants = computed(() => data.value?.data?.restaurants)
</script>

<style lang="scss" scoped>
//
</style>
